import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73f593f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["colspan"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ÜKT tegemise koht:", -1))
const _hoisted_3 = { class: "d-flex flex-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Juhendaja andmed:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AjakavaRidaTabel = _resolveComponent("AjakavaRidaTabel")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_iterator = _resolveComponent("v-data-iterator")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_data_table, {
      class: "my-5 rounded bordered taabel",
      expanded: _ctx.tabel.laiendatud,
      "onUpdate:expanded": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabel.laiendatud) = $event)),
      headers: _ctx.tabel.paised,
      items: _ctx.elemendid,
      "items-per-page": _ctx.tabel.lehePikkus,
      loading: _ctx.tabel.laeb,
      "show-expand": "",
      "fixed-header": "",
      "single-expand": "",
      "item-key": "id"
    }, {
      "expanded-row": _withCtx(({ columns, item }) => [
        _createElementVNode("tr", null, [
          _createElementVNode("td", {
            colspan: columns.length
          }, [
            _createVNode(_component_AjakavaRidaTabel, {
              elemendid: (item.ajakavaList as any)
            }, null, 8, ["elemendid"])
          ], 8, _hoisted_1)
        ])
      ]),
      bottom: _withCtx(() => []),
      _: 1
    }, 8, ["expanded", "headers", "items", "items-per-page", "loading"]),
    _createVNode(_component_v_data_iterator, {
      class: "d-none d-lg-none",
      items: _ctx.elemendid,
      "item-value": "id"
    }, {
      default: _withCtx(({ items }) => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                class: "w-100",
                cols: "auto",
                key: item.raw.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "mx-auto" }, {
                    title: _withCtx(() => [
                      _createTextVNode(" Ajakava nr.: " + _toDisplayString(item.raw.id), 1)
                    ]),
                    prepend: _withCtx(() => [
                      (_ctx.aluseId && _ctx.broneeringuId && _ctx.ajakavaId)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$router.replace({ name: 'uldkasulik_Too', params: { ajakavaRidaId: [_ctx.aluseId.toString(), _ctx.broneeringuId.toString()] } });}),
                            icon: "mdi-chevron-left"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    append: _withCtx(() => [
                      (_ctx.aluseId && _ctx.broneeringuId && !_ctx.ajakavaId)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            onClick: ($event: any) => {_ctx.$router.replace({ name: 'uldkasulik_Too', params: { ajakavaRidaId: [_ctx.aluseId.toString(), _ctx.broneeringuId.toString(), item.raw.id] } });},
                            icon: "mdi-chevron-right"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panels, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel, {
                            title: item.raw.tookohaNimetus
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, {
                                    lines: false,
                                    density: "compact"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        title: item.raw.tegemiseKoht
                                      }, {
                                        title: _withCtx(({ title }) => [
                                          _hoisted_2,
                                          _createTextVNode(" " + _toDisplayString(title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["title"]),
                                      _createVNode(_component_v_list_item, {
                                        title: item.raw.juhendajaAndmed
                                      }, {
                                        title: _withCtx(({ title }) => [
                                          _createElementVNode("div", _hoisted_3, [
                                            _createVNode(_component_v_sheet, { class: "mr-2" }, {
                                              default: _withCtx(() => [
                                                _hoisted_4
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_sheet, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(title, (andmed, i) => {
                                                  return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(andmed), 1))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["title"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}